export function debounce(fn, time) {
    let timerId = undefined;
    return function (...args) {
        if (timerId) {
            clearTimeout(timerId);
        }
        timerId = setTimeout(() => fn(...args), time);
    };
}
